var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-example"},[_c('div',{staticClass:"vue-example__container container"},[_c('BlockCount',{attrs:{"title":_vm.title,"count":_vm.count,"inc":_vm.inc}}),_c('BlockList',{attrs:{"title":_vm.subtitle,"pages":_vm.pages}}),_c('BlockGallery',{attrs:{"slides":_vm.slides}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }